// A rejected write must not be treated as a successful grid response.
export const readResponse = async (response: Response): Promise<Response> => {
    if (!response.ok) {
        let message = `API エラー (${response.status})`;
        try {
            const body = await response.json();
            if (body && typeof body.error === 'string') message = body.error;
        } catch (_) {
            // Proxies and authentication failures may return a non-JSON response.
        }
        throw new Error(message);
    }
    return response;
};
